import { defineStore } from "pinia";
import { fetchPartners, fetchSinglePartner } from "@/api/partner";

export const partnerStore = defineStore("partner", {
    state: () => ({
        partners: [],
        singlePartner: null
    }),

    actions: {
        async loadPartners() {
            const res = await fetchPartners()
            const partners = res.data.data
            this.partners = Array.isArray(partners)
                ? partners
                : [partners]
        },
        async loadSinglePartner(id) {
            try {
                const res = await fetchSinglePartner(id)
                this.singlePartner = res.data.data
            } catch (error) {
                console.error("Failed to load user:", error)
            }
        },
    }
})

